<template>
  <div :class="'d-flex ' + (twoLines ? 'flex-column' : '')">
    <div v-if="isCustom && !embed" class="my-auto">
      <span class="my-auto">
        {{ value.customStartDate | normalDateNoTz }} -
        {{ value.customEndDate | normalDateNoTz }}
      </span>
      <v-btn text color="info" @click="changeDates">
        Change
      </v-btn>
    </div>
    <v-select
      :label="label"
      :value="value.timeframeId"
      :outlined="outlined"
      dense
      :solo="solo"
      :flat="flat"
      hide-details
      :items="filter_items"
      item-text="name"
      item-value="id"
      @change="change"
      :class="{
        'min-width': true,
        'subtitle-2': small,
        'font-weight-regular': small,
        embed: embed
      }"
    >
      <template v-slot:selection="{ item }" v-if="embed">
        <div class="d-flex flex-column">
          <div v-if="isCustom" class="my-auto small-text">
            <span class="my-auto primarytext--text">
              {{ value.customStartDate | normalDateNoTz }} -
              {{ value.customEndDate | normalDateNoTz }}
            </span>
            <v-btn text color="info" @click.stop="changeDates" x-small>
              Change
            </v-btn>
          </div>
          <div>{{ item.name }}</div>
        </div>
      </template>
    </v-select>
    <timeframe-select-dialog
      ref="dialog"
      v-on:apply="apply"
      v-on:cancel="cancel"
    ></timeframe-select-dialog>
  </div>
</template>

<script>
import timeframes from "@/helpers/mixins/timeframes";
import TimeframeSelectDialog from "@/components/reporting/TimeframeSelectDialog";
export default {
  components: { TimeframeSelectDialog },
  name: "TimeframeSelect",
  mixins: [timeframes],
  props: {
    value: {
      type: Object,
      required: true
    },
    label: { type: String, default: "" },
    solo: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    outlined: { type: Boolean, default: true },
    twoLines: { type: Boolean, default: false },
    embed: { type: Boolean, default: false },
    hideCustom: { type: Boolean, default: false },
    small: { type: Boolean, default: false }
  },
  data: () => ({
    oldTimeframeId: null
  }),
  computed: {
    filter_items() {
      let items = [
        {
          id: this.$enums.timeframes.LAST_90_DAYS,
          name: this.getTimeframeName(this.$enums.timeframes.LAST_90_DAYS)
        },
        {
          id: this.$enums.timeframes.LAST_6_MONTHS,
          name: this.getTimeframeName(this.$enums.timeframes.LAST_6_MONTHS)
        },
        {
          id: this.$enums.timeframes.LAST_12_MONTHS,
          name: this.getTimeframeName(this.$enums.timeframes.LAST_12_MONTHS)
        },
        {
          id: this.$enums.timeframes.ALL_TIME,
          name: this.getTimeframeName(this.$enums.timeframes.ALL_TIME)
        }
      ];
      if (!this.hideCustom) {
        items.push({
          id: this.$enums.timeframes.CUSTOM,
          name: this.getTimeframeName(this.$enums.timeframes.CUSTOM)
        });
      }
      return items;
    },
    isCustom() {
      return (
        this.value.timeframeId == this.$enums.timeframes.CUSTOM &&
        this.value.customStartDate != null &&
        this.value.customEndDate != null
      );
    }
  },
  methods: {
    change(timeframeId) {
      this.oldTimeframeId = this.value.timeframeId;
      this.value.timeframeId = timeframeId;
      if (timeframeId == this.$enums.timeframes.CUSTOM) {
        this.$refs.dialog.showDialog(this.value);
      } else {
        this.emit();
      }
    },
    changeDates() {
      this.oldTimeframeId = this.value.timeframeId;
      this.$refs.dialog.showDialog(this.value);
    },
    apply(val) {
      this.value.customStartDate = val.customStartDate;
      this.value.customEndDate = val.customEndDate;
      this.value.customTimezone = val.customTimezone;
      this.emit();
    },
    cancel() {
      this.value.timeframeId =
        this.oldTimeframeId ?? this.$enums.timeframes.LAST_90_DAYS;
      this.emit();
    },
    emit() {
      this.$emit("change", this.value);
      this.$store.dispatch("reporting/setTimeframe", this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.small-text {
  font-size: 8px !important;
}

.embed ::v-deep .v-select__slot .v-input__append-inner {
  align-self: flex-end;
}
</style>
